export const removeNull = (entity) => {
  const propNames = Object.getOwnPropertyNames(entity);
  for (const i in propNames) {
    const propName = propNames[i];
    if (entity[propName] === null || entity[propName] === undefined || entity[propName] === '') {
      delete entity[propName];
    }
  }
  return entity;
};

export * from './debug';
